// Copyright (c) 2021, Comsearch, Inc., All rights reserved

// when you got some segment end ids but you really want to know their path ids.
// returns an Array of path ids
const getPathIdsFromSegmentEndIds = segmentEndIds => (dispatch, getState) => {
  const paths = getState().bulkEdit.get('bulkEditPaths')

  return paths.reduce((a, d) => {
    const segmentEndId1 = d.getIn(['site1', 'segmentEndId'])
    const segmentEndId2 = d.getIn(['site2', 'segmentEndId'])

    if (segmentEndIds.includes(segmentEndId1) || segmentEndIds.includes(segmentEndId2)) {
      a.push(d.get('pathId'))
    }
    return a
  }, [])
}

export default getPathIdsFromSegmentEndIds
